import React, { useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logoImg from "../../public/assets/images/logo.svg";

import styles from "../../styles/components/htmltoPdf.module.scss";
import assest from "../../json/assest";
const HtmlToPdfConverter = () => {
  const [previewImage, setPreviewImage] = useState(null);

  const convertToPdf = async () => {
    const content = document.createElement("div");
    content.innerHTML = `
    <table style="
    width: 100%;
    max-width: 1200px;
    border-spacing: 0px;
    margin: 0 auto;
    padding: 0px;
    font-weight: normal;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    color: #000;
    background-color: #fff;
  ">
  <tr>
    <td style="padding: 0">
      <table style="
          width: 100%;
          border-bottom: 1px solid #f2f2f2;
          padding: 30px 50px;
          font-size: 16px;
          color: #272727;
          line-height: 1.2;
          font-family: Arial, Helvetica, sans-serif;
        ">
        <tr>
          <td style="padding: 0">
            <img src=${logoImg} alt="" />
          </td>
          <td style="
              font-size: 16px;
              color: #393939;
              font-weight: 500;
              text-align: center;
              padding: 0 15px;
            ">
            Content Buyer:
            <span style="color: #000; font-weight: 500">Arseny Pedris</span>
          </td>
          <td style="text-align: right; padding: 0">January 2023 Report</td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0">
      <table style="
          width: 100%;
          font-size: 13px;
          color: #5f5f5f;
          line-height: 1.2;
          font-family: Arial, Helvetica, sans-serif;
          padding: 25px 50px 88px 50px;
          border-bottom: 1px solid #f2f2f2;
        ">
        <tr>
          <td style="
              padding: 0;
              font-size: 16px;
              line-height: 1.2;
              color: #000;
              font-weight: 600;
              padding-bottom: 44px;
            ">
            Payments Breakdown
          </td>
        </tr>

        <tr>
          <td>
            <table style="width: 100%; max-width: 494px; margin: 0 auto">
              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                    padding-bottom: 25px;
                  ">
                  Total amount of purchases
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-left: 10px;
                    padding-bottom: 25px;
                  ">
                  $800
                </td>
              </tr>

              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                    padding-bottom: 25px;
                  ">
                  Total amount requested
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-left: 10px;
                    padding-bottom: 25px;
                  ">
                  $800
                </td>
              </tr>

              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                    padding-bottom: 25px;
                  ">
                  Total amount paid
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #00234c;
                    padding-left: 10px;
                    padding-bottom: 25px;
                  ">
                  $800
                </td>
              </tr>

              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                    padding-bottom: 25px;
                  ">
                  Total amount received
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #004804;
                    padding-left: 10px;
                    padding-bottom: 25px;
                  ">
                  $800
                </td>
              </tr>

              <tr>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.2;
                    color: #5f5f5f;
                    padding-right: 10px;
                  ">
                  Total amount owed
                </td>
                <td style="
                    padding: 0;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.2;
                    color: #531111;
                    padding-left: 10px;
                  ">
                  $800
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0">
      <table style="
          width: 100%;
          font-size: 13px;
          color: #5f5f5f;
          line-height: 1.2;
          font-family: Arial, Helvetica, sans-serif;
          padding: 25px 50px 88px 50px;
          border-bottom: 1px solid #f2f2f2;
        ">
        <tr>
          <td style="
              padding: 0;
              font-size: 16px;
              line-height: 1.2;
              color: #000;
              font-weight: 600;
              padding-bottom: 42px;
            ">
            Payments History
          </td>
        </tr>

        <tr>
          <td>
            <table style="width: 100%; padding: 0 84px">
              <thead>
                <tr>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    Amount Requested
                  </th>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    PayPal
                  </th>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    Amount Paid
                  </th>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    Amount Received
                  </th>
                  <th style="
                      color: #5f5f5f;
                      font-size: 14px;
                      line-height: 1.2;
                      font-weight: 500;
                      padding: 0;
                      padding-right: 20px;
                      text-align: left;
                      padding-bottom: 64px;
                    ">
                    Payment Receipt
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 180px;
                    ">
                    $510
                    <span style="
                        display: block;
                        font-size: 13px;
                        color: #bcbcbc;
                        margin-top: 5px;
                      ">Wednesday, March 16</span>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 190px;
                    ">
                    <a href="#url" style="color: #5f5f5f;text-decoration: none;">kmoore100@816qs.com</a>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    $510
                    <span style="
                        display: block;
                        font-size: 13px;
                        color: #bcbcbc;
                        margin-top: 5px;
                      ">Friday, March 18</span>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    $490
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 0;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    <a href="#url" style="
                        font-weight: 500;
                        color: #20c;
                        text-decoration: underline;
                      ">receipt.png</a>
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 180px;
                    ">
                    $510
                    <span style="
                        display: block;
                        font-size: 13px;
                        color: #bcbcbc;
                        margin-top: 5px;
                      ">Wednesday, March 16</span>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 190px;
                    ">
                    <a href="#url" style="color: #5f5f5f;text-decoration: none;">kmoore100@816qs.com</a>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    $510
                    <span style="
                        display: block;
                        font-size: 13px;
                        color: #bcbcbc;
                        margin-top: 5px;
                      ">Friday, March 18</span>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    $490
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 0;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    <a href="#url" style="
                        font-weight: 500;
                        color: #20c;
                        text-decoration: underline;
                      ">receipt.png</a>
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 180px;
                    ">
                    $510
                    <span style="
                        display: block;
                        font-size: 13px;
                        color: #bcbcbc;
                        margin-top: 5px;
                      ">Wednesday, March 16</span>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 190px;
                    ">
                    <a href="#url" style="color: #5f5f5f;text-decoration: none;">kmoore100@816qs.com</a>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    $510
                    <span style="
                        display: block;
                        font-size: 13px;
                        color: #bcbcbc;
                        margin-top: 5px;
                      ">Friday, March 18</span>
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 20px;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    $490
                  </td>

                  <td style="
                      padding: 0;
                      padding-right: 0;
                      font-size: 13px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      padding-bottom: 32px;
                      vertical-align: top;
                      min-width: 150px;
                    ">
                    <a href="#url" style="
                        font-weight: 500;
                        color: #20c;
                        text-decoration: underline;
                      ">receipt.png</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0">
      <table style="
          width: 100%;
          font-size: 13px;
          color: #5f5f5f;
          line-height: 1.2;
          font-family: Arial, Helvetica, sans-serif;
          padding: 90px 50px 85px 50px;
          border-bottom: 1px solid #f2f2f2;
        ">
        <tr>
          <td style="
              padding: 0;
              font-size: 16px;
              line-height: 1.2;
              color: #000;
              font-weight: 600;
              padding-bottom: 26px;
            ">
            Purchased Videos
            <span style="
                background: #f8f8f8;
                border-radius: 11px;
                padding: 8px 15px;
                font-size: 13px;
                font-weight: 500;
                line-height: 1.2;
                color: #000;
                margin-left: 15px;
                display: inline-block;
                vertical-align: middle;
              ">16</span>
          </td>
        </tr>

        <tr>
          <td>
            <table style="width: 100%; padding: 0 103px; border-spacing: 0">
              <thead>
                <tr>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 75px;
                      border-radius: 14px 0 0 0;
                    ">
                    VSID
                  </th>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 100px;
                    ">
                    Owner Name
                  </th>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 130px;
                    ">
                    Email Address
                  </th>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 110px;
                    ">
                    Purchase Date
                  </th>
                  <th style="
                      padding: 0;
                      text-align: left;
                      padding: 10px 34px;
                      background: #f8f8f8;
                      min-width: 100px;
                      border-radius: 0 14px 0 0;
                      text-align: right;
                    ">
                    Purchase Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 1px solid #efefef;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>

                <tr>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 0;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    #13194
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 0;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    John Smith
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 0;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    <a href="mailto:johnsmith@gmail.com"
                      style="color: #6c6868; text-decoration: none">johnsmith@gmail.com</a>
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 0;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                    ">
                    January 24, 2023
                  </td>
                  <td style="
                      padding: 14px 34px;
                      border-bottom: 0;
                      font-size: 12px;
                      line-height: 1.2;
                      color: #5f5f5f;
                      font-weight: 500;
                      text-align: right;
                    ">
                    $80
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0;">
      <table style="width: 100%;border-bottom: 1px solid #F2F2F2;padding: 25px 50px;">
        <tr>
          <td
            style="padding: 0;text-align: center;color: #A1A1A1;font-size: 14px;line-height: 1.2;font-weight: 400;">
            Have any questions or need assistance? Please reach out to our team at <a href="info@viralsnare.com"
              style="color: #A1A1A1;text-decoration: none;">info@viralsnare.com</a></td>
        </tr>
      </table>
    </td>
  </tr>

  <tr>
    <td style="padding: 0;">
      <table style="width: 100%;padding: 33px 50px;">
        <tr>
          <td style="padding: 0;text-align: center;">
            <span
              style="font-size: 24px;line-height: 1.2;font-weight: 500;color: #000;background: #F6F6F6;border-radius: 14px;display: inline-block;min-width: 394px;text-align: center;padding: 21px 20px;">SEE
              YOU NEXT MONTH :D</span>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    `;
    content.style.position = "absolute";
    content.style.left = "-9999px";
    document.body.appendChild(content);
    const pdf = new jsPDF({
      unit: "mm", // Use millimeters as the unit for dimensions
      format: [216, 400], // Set custom page dimensions
    });
    // const content = document.getElementById("contentToConvert");
    // const content = pdftable()
    html2canvas(content).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      setPreviewImage(imgData);
      pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
      pdf.save("Form.pdf");
      document.body.removeChild(content);
    });
  };

  return (
    <div>
      <button onClick={convertToPdf}>
        {" "}
        <img src={assest.downloadReportIcon} width={17} height={15} alt="" />
      </button>

      {/* {previewImage && (
        <div>
          <h2>Preview Image:</h2>
          <img src={previewImage} alt="PDF Preview" />
        </div>
      )} */}
    </div>
  );
};

export default HtmlToPdfConverter;
